<template>
  <div class="live">
    <div class="mainWidth main_box" style="background:#fff">
      <div class="map">
        <!-- <commap></commap> -->
      </div>
      <div class="phone"></div>
      <mu-row gutter class="contactUs">
        <mu-col  class="left" width="100" tablet="100" desktop="50">
          <p class="cxt_info">
            {{$t('comfooter.contextInfo')[6]}}
          </p>
          <p class="cxt_info">
            {{$t('comfooter.contextInfo')[2]}}
          </p>
          <p class="cxt_info">
            {{$t('comfooter.contextInfo')[3]}}
          </p>
        </mu-col>
        <mu-col class="right" width="100" tablet="100" desktop="50">
          <p class="cxt_info">
            {{$t('comfooter.contextInfo')[4]}}
          </p>
          <p class="cxt_info">
            {{$t('comfooter.contextInfo')[5]}}
          </p>
          <p class="cxt_info">
            {{$t('comfooter.contextInfo')[7]}}
          </p>
        </mu-col>
      </mu-row>
    </div>
  </div>
</template>

<script>
  import commap from '../../components/commap'
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    components:{
        commap
    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .live{
    overflow:hidden;
    background-color:#E6E6E6;
    padding-bottom:60px;
    .main_box{
      padding:60px 100px;
      background:#fff;
      margin-top:10px;
      .map{
        background:#fff;
        overflow:hidden;
        width:512px;
        height:351px;
        margin-top:17px;
        margin:17px auto;
        color:#FFF;
        background:url(../../assets/images/map.png) no-repeat center center;
        background-size:100% 100%;
      }
      .phone{
        width:374px;
        height:55px;
        margin:42px auto;
        background:url("../../../static/phone.png") no-repeat center center;
        background-size:100% 100%;
      }
      .contactUs{
        background: #F9F9F9;
        padding:39px 0px;
        .right,.left{
          padding-left:180px;
          .cxt_info{
            font-size: 14px;
            color: #3B3B3B;
            letter-spacing: 0;
            line-height: 33px;
          }
        }
      }

    }
  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/contact.vue